import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
import { ImageModule } from '@df/module-image/image.module';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsContent, NICmsContentField } from '@icms/core/content';
import { ICmsComponent } from '@icms/core/content/component/icms-component.decorator';
import { TypeDropdownComponent } from 'projects/app-default/src/app/ui/common/type-dropdown/type-dropdown.component';
import { AbstractDeliveryInfoComponent } from '../../delivery-info/abstract-delivery-info.component';
import { NDeliveryConfiguration } from '../../delivery-info/delivery-info.interfaces';

export const productDeliveryInfoModalId = 'product-delivery-info-modal';

@DfCmsModal({
    id: productDeliveryInfoModalId,
    position: 'right',
    config: sizeName => ({
        width: { S: '355px', M: '355px', L: '648px', X: '648px' }[sizeName],
        height: '100vh',
        position: {
            top: '0',
            right: '0',
            bottom: '0'
        },
        maxWidth: '100vw'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['L', 'X']),
    prerenderAllowed: false,
    name: 'Product Delivery Info Modal'
})
@ICmsComponent({
    id: productDeliveryInfoModalId,
    block: {
        url: productDeliveryInfoModalId,
        resolvers: {
            countries: () => {
                return inject(DfApiConfigService).loadCountries();
            }
        }
    },
    onDemandOnly: true,
    name: 'Product Delivery Info Modal',
    fields: [
        {
            key: 'returnsTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Returns Title',
            required: true,
            default: 'Returns'
        },
        {
            key: 'returnsText',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Returns Text',
            required: true,
            default: `We accept returns and exchanges within 60 days of receipt.`
        }
    ]
})
@Component({
    selector: 'product-delivery-info-modal',
    templateUrl: './product-delivery-info-modal.html',
    styleUrls: ['product-delivery-info-modal.scss'],
    standalone: true,
    imports: [FormsModule, TranslationModule, ImageModule, ICmsClientModule, PriceComponent, TypeDropdownComponent, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDeliveryInfoModalComponent extends AbstractDeliveryInfoComponent {
    private modalRef = inject(ModalRef<ProductDeliveryInfoModalComponent>);

    @ICmsContent({
        type: 'blockContent'
    })
    content?: NDeliveryConfiguration.IModalData;

    protected close(): void {
        this.modalRef.close();
    }
}
